<template>
   <div ref="leadFileListRef">

      <div class="files-list">

         <ul class="pb-2">
            <li v-for="file in allLeadFiles" :key="file.id">
               <div class="file-wrapper">
                  <div class="pb-3 file-icon">
                     <img :src="require('@/assets/img/file_type_icons/'+getFileTypeIcon(file.file_extension))" alt="File Icon"/>
                  </div>

                  <span class="file-download-icon" title="Click to download file" @click="downloadFile(file)">
                     <i class="fa-regular fa-circle-down"></i>
                  </span>

                  <div class="pt-3 file-name" :title="file.file_name">{{ formatText(file.file_name) }}</div>

                  <div class="pt-1 file-upload-date" :title="file.uploaded_at">{{ formatDate(file.uploaded_at) }}</div>
         
               </div>
               
               <span :id="file.id" :ref="file.id" class="loading d-none">
                  <span class="spinner-border text-dark" role="status">
                     <span class="visually-hidden">Downloading file...</span>
                  </span>
               </span>
            </li>
            
         </ul>
      </div>
      
   </div>
</template>

<script>
import moment from 'moment'
import { truncateLongText, getFileTypeIcon } from '@/plugins/helper.js'

export default({
   
   data(){
      return {
         allLeadFiles: [],
         leadFiles: [],
         proposalFiles: [],
      }
   },

   emits: ['downloadFile', 'downloadAllFiles'],

   methods: {
      init(id){
         this.getAllLeadFiles(id)
      },

      formatDate(date){
         return moment(date).format("DD-MMM-YYYY")
      },

      formatText(text){
         return truncateLongText(text, 15)
      },

      getFileTypeIcon(type){
         return getFileTypeIcon(type)
      },

      async getAllLeadFiles(id){

         await this.$axios.get("/leads/"+id+"/files")
         .then((response) => {
            this.leadFiles = response.data.files
            this.proposalFiles = response.data.proposals

            this.allLeadFiles = []
            this.allLeadFiles = [...response.data.files, ...response.data.proposals]

            // sort by latest uploaded file
            this.allLeadFiles.sort(function(a,b) { 
               return new Date(b.uploaded_at).getTime() - new Date(a.uploaded_at).getTime() 
            });

         })
         .catch((error) => {
            this.$toast.error(error.response.data.message)
         })

      },

      downloadFile(file){
         //show loading icon
         this.$refs[file.id][0].classList.remove('d-none')

         //check if file is from pentest or a proposal
         let fileOrigin = "pentest"
         if (file.lead_proposal_id != "" && (file.product_id == "" || typeof file.product_id === 'undefined')){
            fileOrigin = "proposal"
         }

         this.$emit('downloadFile', {fileOrigin: fileOrigin, file : file})
      },

      downloadFileDone(fileId) {
         //remove loading icon
         this.$refs[fileId][0].classList.add('d-none')
      },

   }
})
</script>

<style scoped>
.files-list ul {
	list-style: none;
	padding: 0px 5px;
	margin: 0;
	display: flex;
	flex-wrap: wrap;
	overflow-wrap: break-word;
   font-size: 13px;
}

.files-list ul>li {
   position: relative;
	display: inline-block;
	padding: 0.5rem;
   margin: 0.5rem;
	width: calc(100%/4.5);
   /* background-color: bisque; */
   text-align: center;
}

.files-list .file-download-icon {
   position: absolute;
   z-index: 2;
   right: 5%;
   bottom: 40%;
   display: none;
   font-size: 20px;
   color: gray;
   cursor: pointer;
}

.files-list .file-download-icon:hover{
   color: #435666;
}

.files-list .file-wrapper:hover .file-download-icon {
	display: block;
}

.files-list .file-icon {
   height: 75px;
}

.files-list .file-icon img {
   height: 75px;
}

.files-list .file-name {
	color: #00A0C1;
}
.files-list .file-upload-date {
	color: #435666;
   padding-bottom: 1rem;
}

.loading{
   position: absolute;
   z-index: 999;
   height: 100%;
   width: 100%;
   text-align: center;
   background-color: #D9D9D9;
   opacity: 0.8;
   top: 0;
   left: 0;
   padding: 0.5rem;
   color: gray;
}

.loading .spinner-border{
   height: 3rem;
   width: 3rem;
   margin-top: 25%;
   text-align: center;
}
</style>
